// What counts as one emoji (M69, docs/emojis.md): shared so the server's
// reaction check (D21, D264) and the web's big-emoji rule (D265) agree.
// One emoji, as a whole grapheme: a flag (two regional indicators or a tag
// sequence), a keycap, or a pictograph with its modifiers and ZWJ parts.
const PICTOGRAPH = '\\p{Extended_Pictographic}(?:\\uFE0F|\\p{Emoji_Modifier})?(?:\\u20E3)?';
/** One emoji sequence (no anchors), for building patterns. */
export const EMOJI_SEQUENCE_SOURCE = `\\p{Regional_Indicator}{2}` +
    `|[#*0-9]\\uFE0F?\\u20E3` +
    `|\\u{1F3F4}[\\u{E0020}-\\u{E007E}]+\\u{E007F}` +
    `|${PICTOGRAPH}(?:\\u200D${PICTOGRAPH})*`;
const ONE_EMOJI = new RegExp(`^(?:${EMOJI_SEQUENCE_SOURCE})$`, 'u');
/**
 * Exactly one emoji, drawn as an emoji: © or ™ typed as text is a
 * pictograph too, but only counts with U+FE0F (©️). Keycaps (1️⃣, #️⃣),
 * ℹ️, flags, ZWJ families and skin tones are each one emoji.
 */
export function isSingleEmoji(value) {
    return (/\p{Emoji_Presentation}|️|⃣|\p{Regional_Indicator}|\p{Emoji_Modifier}|‍/u.test(value) && ONE_EMOJI.test(value));
}
/**
 * One spelling per emoji, so 👍 and 👍️ (with U+FE0F) are the same reaction
 * and the same recent (D264). A single character that is shown as an emoji
 * anyway drops the variation selector; one that would be text without it
 * (❤️, ℹ️) keeps or gains it. Sequences (ZWJ, skin tones, flags, keycaps)
 * are left alone.
 */
export function canonicalEmoji(emoji) {
    const bare = emoji.replace(/️/g, '');
    if ([...bare].length !== 1)
        return emoji;
    if (!/\p{Extended_Pictographic}/u.test(bare))
        return emoji;
    return /\p{Emoji_Presentation}/u.test(bare) ? bare : `${bare}️`;
}
//# sourceMappingURL=emoji.js.map